// extracted by mini-css-extract-plugin
export default {"result__item":"ResultSearch_result__item__EWDYM","result__item__img":"ResultSearch_result__item__img__ejL8a","result__item__info":"ResultSearch_result__item__info__MVWuO"};